module.exports = __webpack_public_path__ + "img/newport_btn.0a98d2d6.svg";